import { EOrganization, ERef } from '.';
import { OptimizerHyperparams } from './api';

export type LayoutHeader = {
  headerId: string;
  width: 'column' | 'layout';
};

export type AllowedLayout = {
  columns: number;
  heightPixels: number;
  layoutHeader: LayoutHeader | null;
  id: string;
  fillers: Filler[];
};

export type Filler = {
  name: string;
  pdfUrl: string;
  columns: number;
  height: number;
  id: string;
  maxOccurrences: number;
};

export type SeparatorConfig = {
  enabled: boolean;
  includeColumns: number[];
};
export const DEFAULT_SEPARATOR_CONFIG: SeparatorConfig = {
  enabled: false,
  includeColumns: []
};

type VariantConfig = {
  disabled: boolean;
};

export type BorderingConfig = {
  thickness: number;
  excludedColumns: number[];
};

export type LayoutSettingsConfig = {
  minHeight: number;
  heightIncrements: number;
  headerId?: string;
  minColumns?: number;
};
export const DEFAULT_LAYOUT_SETTINGS: LayoutSettingsConfig = {
  minHeight: 72,
  heightIncrements: 36,
  // This is checked in layoutIsValidForOrders, ensuring that all layouts we present to our
  // optimizer have at least this number of columns
  // This can be used as a way of enforcing "horizontal prioritization", by forcing all layouts
  // to take up the full width
  // Should this strategy be insufficient, we should follow up by improving getPotentialPublisherLayouts
  // with an explicit "horizontal" planning mode
  minColumns: 1
};

type Header = {
  applyToColumns: number[];
  url: string;
  width: number;
  id: string;
};
type HeaderWithHeight = Header & {
  height: number;
};
export type HeaderSettingsConfig = {
  headers: Header[];
};
export type HeaderSettingsConfigWithHeight = {
  headers: HeaderWithHeight[];
};

export type ExternalAdsConfig = {
  bucket: string;
  momentFormattedFolder: string;
};
export const DEFAULT_EXTERNAL_ADS_CONFIG: ExternalAdsConfig = {
  bucket: 'nypa-document-migration',
  momentFormattedFolder: 'YYYY/MM-DD'
};

export type CombinedPublisherConfig = {
  includedPublisherIds: string[];
  enabled: boolean;
};
export const DEFAULT_COMBINED_PUBLISHERS_CONFIG: CombinedPublisherConfig = {
  includedPublisherIds: [],
  enabled: false
};

export type PublisherPaginationSettings = {
  enableAdSplitting: boolean;
  flowText: boolean;
  fillers: Omit<Filler, 'height'>[];
  allowedPublishers: ERef<EOrganization>[];
  owner: ERef<EOrganization>;
  separators: SeparatorConfig | undefined;
  variants?: VariantConfig | undefined;
  bordering?: BorderingConfig | undefined | null;
  optimizerHyperparams?: OptimizerHyperparams | undefined | null;
  layoutSettings?: LayoutSettingsConfig | undefined | null;
  headerSettings?: HeaderSettingsConfig | undefined | null;
  externalAdSettings?: ExternalAdsConfig | undefined | null;
  combinedPublisherConfig?: CombinedPublisherConfig | undefined | null;
};
